<template>
  <!-- XOL-446: until the pre-auth branding fetch settles we show the app's own
       six-bar boot loader (the one index.html renders while the bundle
       downloads) rather than a half-built login screen. Reusing it keeps the
       cold-boot -> branding-resolved sequence a single continuous animation
       instead of two different loading treatments back to back. -->
  <app-loader v-if="brandingLoading" class="login-loader" />

  <el-container v-else-if="!localReg" class="bg-gradient">

    <vue-particles
    color="#66B1FF"
    :particleOpacity="0.7"
    :particlesNumber="108"
    :particleSize="5"
    linesColor="#909399"
    :lineOpacity="0.528" />


    <el-aside v-if="isDesktop" style="background-color: #545c6480;">

    <el-menu
       background-color="#2f3e5785"
       text-color="#fff"
       active-text-color="#ffd04b"
       default-active="1-1">

      <el-submenu index="1">
        <template #title>
          <i class="fa fa-list"></i>
          <span>Features</span>
        </template>

        <el-menu-item-group title="Any Organisation:">
          <el-menu-item index="0-1"><i class="fa fa-star" />&nbsp;Tower Companies, <i class="fa fa-users" />&nbsp;Telcos</el-menu-item>
          <el-menu-item index="0-2"><i class="fa fa-wifi" />&nbsp;Backhaul Providers</el-menu-item>
          <el-menu-item index="0-3"><i class="fa fa-tools" />&nbsp;Contractors, <i class="fa fa-store-alt" />&nbsp;Landlords</el-menu-item>
          <el-menu-item index="0-4"><i class="fa fa-broadcast-tower" />&nbsp;Tower Suppliers</el-menu-item>
          <el-menu-item index="0-5"> <i class="fa fa-clipboard" />&nbsp;Authorities, <i class="fa fa-plug" />&nbsp;Utilities</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Projects:">
          <el-menu-item index="1-1"><i class="fa fa-share-alt" />&nbsp;Request to Share</el-menu-item>
          <el-menu-item index="1-2"><i class="fa fa-wrench" />&nbsp;Request to Upgrade</el-menu-item>
          <el-menu-item index="1-3"><i class="fa fa-wifi" />&nbsp;Request to Backhaul</el-menu-item>
          <el-menu-item index="1-4"><i class="fa fa-broadcast-tower" />&nbsp;View All Your Sites</el-menu-item>
          <el-menu-item index="1-5"><i class="fa fa-tools" />&nbsp;Installed Equipment</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Service:">
          <el-menu-item index="2-4"><i class="fa fa-headset" />&nbsp;Instant Tickets</el-menu-item>
          <el-menu-item index="2-5"><i class="fa fa-list" />&nbsp;Custom Workflows</el-menu-item>
        </el-menu-item-group>

      </el-submenu>

      <el-menu-item index="2">
        <i class="fa fa-th-large"></i>
        <span>Easy, Mobile Friendly</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="fa fa-user-cog"></i>
        <span>Consistent, Accurate Data</span>
      </el-menu-item>
    </el-menu>

  </el-aside>

  <el-main>

    <div>
      <el-row>

        <el-col v-if="isDesktop" :xs="0" :sm="24" :md="24" :lg="8">
            <el-col  v-for="(l, i) in telcoLogos" :key="i" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
              <img class="logo" :src="l.src" :alt="l.alt" />
            </el-col>
        </el-col>

        <el-col style="padding-bottom: 2.85rem;" class="inner-box" :xs="24" :sm="24" :md="24" :lg="8" align="center">

          <center><img v-if="clientLogo" style="height: 2.85rem; padding: 0.8em;" :src="clientLogo" :alt="clientName"></center>

          <div v-if="!isMaint && !isUnpaid">

            <!-- XOL-602/603/604: the box shows one of five things, by route (see `mode`).
                 `login` is today's form. The others are the signed-out pages of the
                 password-link feature, in the same box under the same client logo; they sit
                 inside this v-if, so Under Maintenance / Overdue Payment hide every one. -->
            <template v-if="mode === 'login'">

            <div
              v-if="logoutReason === 'session-expired'"
              class="session-expired-msg"
              role="status">
              <i class="fa fa-exclamation-circle" />&nbsp;Your session has expired. Please sign in again.
            </div>

            <div
              v-if="logoutReason === 'api-access-denied'"
              class="session-expired-msg"
              role="status">
              <i class="fa fa-ban" />&nbsp;This service can't be reached right now. Please contact your administrator.
            </div>

            <el-form style="padding: 2.85rem;">

                <el-form-item>
                  <el-input style="max-width: 400px; margin:  0 auto;" v-model="login" placeholder="Login" type="text" :disabled="loggingIn" @keyup.native.enter="submitOnEnter" />
                </el-form-item>

                <el-form-item>
<!--                  <el-input v-model="pwd" placeholder="Password" type="password" /> -->
                <password v-model="pwd" toggle @keyup.native.enter="submitOnEnter" />
                </el-form-item>

              <el-row>
                <el-form-item>
                  <el-button type="primary" icon="fa fa-right-to-bracket" :loading="loggingIn" :disabled="loggingIn || (!login) || (!pwd)" @click="doLogin">&nbsp;{{ loggingIn ? 'Signing in...' : 'Login' }}</el-button>
                </el-form-item>

                <!-- XOL-604: between Login and Register, centred like them. -->
                <el-form-item>
                  <el-button type="text" :disabled="loggingIn" @click="goForgot">Forgot password?</el-button>
                </el-form-item>

                <el-form-item>
                  <el-button type="danger" icon="fa fa-user-plus" :disabled="loggingIn || !(!login && !pwd)" @click="doRegister">&nbsp;Register</el-button>
                </el-form-item>
              </el-row>

            </el-form>

            </template>

            <!-- XOL-604: /forgot-password. The Login field's text is handed over in memory. -->
            <forgot-password v-else-if="mode === 'forgot'" :prefill="login || ''" />

            <!-- XOL-603/602: /reset-password/:token and /set-password/:token. Keyed by the
                 token so a different link remounts the page and inspects again. -->
            <reset-password v-else-if="mode === 'link'" :key="routeToken"
              :token="routeToken" :purpose="linkPurpose" @done="onLinkDone" />

            <!-- XOL-602: /register/:token, an invitation to register. -->
            <invite-register v-else-if="mode === 'invite'" :key="routeToken"
              :token="routeToken" @done="onLinkDone" @prefill-login="onPrefillLogin" />

            <!-- /password-set: the success state, held in memory only (a cold load has none
                 and is sent to /login: this page must never claim a success it cannot prove). -->
            <login-panel v-else-if="mode === 'done' && done">
              <el-alert type="success" show-icon :closable="false" :title="doneSpec.title" :description="doneSpec.desc" />
              <div class="login-panel__actions">
                <div><el-button ref="doneAction" type="primary" icon="fa fa-right-to-bracket" @click="goToLogin">Go to login</el-button></div>
              </div>
            </login-panel>

          </div>

          <div v-else style="margin-bottom: 1rem;">
            <center v-if="isMaint"><h2 class="text-warning">Under Maintenance</h2></center>
            <center v-if="isUnpaid"><h2 class="text-danger">Overdue Payment</h2></center>
          </div>

          <div class="xolas-logo">
            <a href="https://xolas.io" target="_blank"> Powered by&nbsp;<img class="footer-logo" :src="logo" />&nbsp;
            {{appName}}</a>
          </div>

        </el-col>

        <el-col v-if="isDesktop" :xs="0" :sm="24" :md="24" :lg="8">
            <el-col  v-for="(l, i) in otherLogos" :key="i" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
              <img class="logo" :src="l.src" :alt="l.alt" />
            </el-col>
        </el-col>


      </el-row>

    </div>

  </el-main>

</el-container>

<el-container v-else>
  <register :new-system="xolasClient().contactsCount == 0 ? true : false" />
</el-container>

</template>

<script>

import Vue from 'vue'

import {APP_NAME, IS_MAINT, IS_UNPAID, IS_DEV} from '@/components/Data'

import VueParticles from 'vue-particles'
import ProgressiveBackground from 'vue-progressive-image'

import Password from 'vue-password-strength-meter'
import Register from '@/components/login/Register'
import LoginPanel from '@/components/login/LoginPanel'
import ForgotPassword from '@/components/login/ForgotPassword'
import ResetPassword from '@/components/login/ResetPassword'
import InviteRegister from '@/components/login/InviteRegister'
// Imported locally rather than leaning on the global atoms registration:
// Login renders before anything else, and the dependency should be visible
// here (and resolvable in unit tests, which mount on a bare localVue).
import AppLoader from '@/components/atoms/AppLoader'
import { takeLogoutReason } from '@/lib/session'

Vue.use(ProgressiveBackground)
Vue.use(VueParticles)

// XOL-446: upper bound on how long the branding fetch may gate the form.
const BRANDING_TIMEOUT_MS = 5000

export default {

  components: {
    AppLoader,
    Password,
    Register,
    LoginPanel,
    ForgotPassword,
    ResetPassword,
    InviteRegister
  },

  data () {
    return {
      appName: APP_NAME,
      isMaint: IS_MAINT,
      isUnpaid: IS_UNPAID,
      isDev: IS_DEV,
      localReg: false,
      // KAN-39 / acceptance #11: populated on mount when the axios
      // interceptor forced a redirect (e.g. terminal 401 / refresh
      // failure). Read once, then cleared so a later manual /login
      // visit does not re-show the banner.
      logoutReason: null,
      login: null,
      pwd: null,
      loggingIn: false,
      // XOL-602/603/604: what /password-set shows: {variant: 'reset'|'invite'|'registered',
      // login}. In memory only, set by the link pages just before they replace the route.
      done: null,
      // XOL-446: the login screen revalidates its branding against the server
      // on every mount, so a DB swap or a client change can never leave the
      // previous deployment's logo and name on screen. The form stays
      // disabled until that settles — success OR failure.
      brandingLoading: true,
      brandingTimer: null,
      media: {xs: 24, sm: 12, md: 12, lg: 12},
      logo: '../../../static/favicon.png',
      telcoLogos: [
        {src: '../../../static/clients/celcomdigi.png', alt: 'CelcomDigi'},
        {src: '../../../static/clients/maxis.png', alt: 'Maxis'},
        {src: '../../../static/clients/umobile.png', alt: 'U-Mobile'},
        {src: '../../../static/clients/unifi-mobile.png', alt: 'Unifi Mobile'},
        {src: '../../../static/clients/yes.png', alt: 'Yes'},
        {src: '../../../static/clients/sapura-logo-real.svg', alt: 'Sapura'}
      ],
      otherLogos: [
        {src: '../../../static/clients/tm.png', alt: 'Telekom Malaysia'},
        {src: '../../../static/clients/time.png', alt: 'TIME'},
        {src: '../../../static/clients/dnb-logo.svg', alt: 'DNB'},
        {src: '../../../static/clients/dhti.png', alt: 'D\'Harmoni'},
        {src: '../../../static/clients/micth.png', alt: 'MICTH'},
        {src: '../../../static/clients/cttsb-logo.png', alt: 'Common Tower'},
//        {src: '../../../static/clients/teleflow.png', alt: 'Tele-Flow'}
      ]

    }
  },

  computed: {
    // Read reactively from the Vuex store so a late /api/system/client
    // response (fresh session / incognito) still populates the logo —
    // a plain data() snapshot fires before the XHR resolves.
    clientName () {
      return this.xolasClient().name
    },
    clientLogo () {
      return this.xolasClient().logoPath
    },

    // XOL-602/603/604: which of the five things the box shows, from the route name.
    // `login` (today's form, and any route not named below) | `forgot` | `link` (a reset or
    // an invitation to set a password) | `invite` (an invitation to register) | `done`.
    mode () {
      var name = this.$route ? this.$route.name : null
      if (name === 'Forgot Password') return 'forgot'
      if (name === 'Reset Password' || name === 'Set Password') return 'link'
      if (name === 'Register Invite') return 'invite'
      if (name === 'Password Set') return 'done'
      return 'login'
    },

    // /set-password is an invitation to set a first password; /reset-password is a reset.
    linkPurpose () {
      return (this.$route && this.$route.name === 'Set Password') ? 'invite' : 'reset'
    },

    // The link's secret, from the route param. Handed to the page as a prop; never stored.
    routeToken () {
      return (this.$route && this.$route.params && this.$route.params.token) || ''
    },

    // UX section 6 (and 17, `registered`).
    doneSpec () {
      var variant = this.done ? this.done.variant : null
      var login = this.done ? this.done.login : ''
      if (variant === 'registered') {
        return { title: 'Your account has been created', desc: 'Log in with Login ID ' + login + ' and the password you chose.' }
      }
      if (variant === 'invite') {
        return { title: 'Your password has been set', desc: 'Log in with Login ID ' + login + ' and your new password.' }
      }
      return {
        title: 'Your password has been changed',
        desc: 'Log in with Login ID ' + login + ' and your new password. Any device that was signed in to this account has been signed out.'
      }
    }
  },

  watch: {
    // Back to /password-set after its state was used (or cleared) has nothing to show.
    mode () {
      this.leaveEmptyDone()
    },

    // The success button takes focus when the page appears (UX section 6).
    done (value) {
      if (value) {
        this.$nextTick(() => {
          var button = this.$refs.doneAction
          if (button && button.$el && typeof button.$el.focus === 'function') {
            button.$el.focus()
          }
        })
      }
    }
  },

  methods: {

    doLogin () {
      if (this.loggingIn) {
        return
      }
      this.loggingIn = true
      const result = this.canLogin(this.login, this.pwd)
      if (result && typeof result.then === 'function') {
        result.then(() => { this.loggingIn = false }, () => { this.loggingIn = false })
      } else {
        this.loggingIn = false
      }
    },

    // XOL-604: to the forgot-password page. The typed Login (never the password) goes along
    // in memory; a password typed here does not stay behind in this component.
    goForgot () {
      this.pwd = null
      this.$router.push('/forgot-password')
    },

    // A link page succeeded (it has already asked for /password-set, or is about to).
    onLinkDone (payload) {
      this.done = payload || null
    },

    // The Login ID to show in the Login field when the user returns to /login.
    onPrefillLogin (login) {
      this.login = login || null
    },

    // "Go to login" on /password-set: the Login field is prefilled with the Login ID.
    goToLogin () {
      if (this.done && this.done.login) {
        this.login = this.done.login
      }
      this.pwd = null
      this.done = null
      this.$router.push('/login')
    },

    // /password-set with no success in memory (a cold load, or Back after it was used):
    // nothing to prove, so go to /login.
    leaveEmptyDone () {
      if (this.mode === 'done' && !this.done) {
        this.$router.replace('/login')
      }
    },

    doRegister () {

      if (!this.localReg) {
        this.localReg = true
      }

    },

    submitOnEnter () {
      if (this.loggingIn || this.brandingLoading || !this.login || !this.pwd) return
      this.doLogin()
    },

    onBrandingSettled () {
      if (this.brandingTimer) {
        clearTimeout(this.brandingTimer)
        this.brandingTimer = null
      }
      this.brandingLoading = false
    }

  },

  created () {
    this.leaveEmptyDone()

    // XOL-446: cap the wait. axios-retry is configured for 3 retries with
    // exponential backoff on network errors, so a dead API can hold this
    // promise for several seconds — without the cap the form would be
    // permanently disabled on a cold offline boot. The requirement is that a
    // failed branding fetch still leaves the screen usable.
    this.brandingTimer = setTimeout(this.onBrandingSettled, BRANDING_TIMEOUT_MS)

    // refreshClientBranding() always resolves, but pass both handlers so an
    // unexpected rejection still releases the form. Two-arg .then rather than
    // .finally — Babel 6 does not polyfill .finally().
    var settled = this.onBrandingSettled
    var result = this.refreshClientBranding()
    if (result && typeof result.then === 'function') {
      result.then(settled, settled)
    } else {
      settled()
    }
  },

  beforeDestroy () {
    if (this.brandingTimer) {
      clearTimeout(this.brandingTimer)
      this.brandingTimer = null
    }
  },

  mounted () {
    // KAN-39 / acceptance #11: surface why the user was bounced here.
    //
    // XOL-446: this used to read and remove `xolas-logout-reason` from
    // sessionStorage inline. App.vue re-creates <login> whenever showLogin
    // changes, and it mounts more than once during a teardown — so the
    // instance that consumed the key was often not the one left on screen,
    // and the banner vanished. takeLogoutReason() consumes the key once and
    // latches the value for the life of the document, so every mount agrees.
    this.logoutReason = takeLogoutReason()
  }
}
</script>

<style scoped>

.logo {
  width: auto;
  height: 1.852rem;
  padding-top: 2rem;
}

.footer-logo {
  width: auto;
  height: 1.396rem;
}

/* XOL-446: give the branding gate the same full-height, centred presentation
   as index.html's boot loader, so cold boot -> branding-resolved reads as one
   continuous step rather than the loader jumping position. App.vue's footer
   still renders below it. */
.login-loader {
  min-height: 80vh;
}

.inner-box {
  padding-top: 1em;
  border-radius: 8.52px;
  background-color: #FFFAFA96;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.0852), 0 6px 20px 0 rgba(0, 0, 0, 0.0852);
}

.xolas-logo {
  width: 280px;
  margin-top: 35px;
  margin-bottom: 24px;
  text-align: center;
  align-items: center;
  font-size: 10pt;
  color: lightgrey;
}

.xolas-logo a:link {
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  color: lightgrey;
}

.session-expired-msg {
  margin: 0.8rem 1.5rem 0;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  background-color: #fef0f0;
  color: #b54141;
  font-size: 13px;
  text-align: center;
}

.bg-gradient {
/*
  background: rgb(214,149,94);
  background: linear-gradient(270deg, rgba(214,149,94,1) 0%, rgba(183,117,60,1) 56%, rgba(75,44,21,1) 100%);
*/
  background: url('/static/login/background.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

#particles-js {
    position: absolute;
    background: inherit;
    left: 9px;
    right: 9px;
    top: 9px;
    bottom: 0;
}

</style>
